import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { STATUS_STYLES, TYPE_CONFIGS, STATUS_DISPLAY_TEXT, getIcon } from "./NotificationItem.consts";
import { getNotificationStepText, formatRelativeTime } from "./NotificationItem.utils";
import {
  NotificationContainer,
  IconContainer,
  ContentContainer,
  StatusContainer,
  StatusBadge,
  SmallText,
  PublishDescription
} from "./NotificationItem.styles";
import StickyNoteIcon from "src/icons/StickyNoteIcon";

const NotificationItem = ({ id, type, createdAt, channel, steps, publishDescription, status, isExpanded, onClick }) => {
  const config = TYPE_CONFIGS[type];
  const statusStyle = STATUS_STYLES[status];
  const Icon = getIcon(type, channel);
  const stepText = getNotificationStepText(status, steps);

  return (
    <NotificationContainer id={id} status={statusStyle} data-testid="notification-item" onClick={onClick} isExpanded={isExpanded}>
      <IconContainer>
        <Icon />
      </IconContainer>
      <ContentContainer>
        <Box>
          <Typography variant="tableHeader1" component="h3" color="text.800" data-testid="notification-title">
            {config.title}
          </Typography>
          <Typography variant="caption" component="p" color="text.800" sx={{ minHeight: isExpanded ? "auto" : "36px" }} data-testid="notification-message">
            {config.messages[status]}
          </Typography>
        </Box>
        {publishDescription &&
          <Stack sx={{ mb: "8px" }} direction="row" alignItems="center" gap={0.75}>
            <StickyNoteIcon />
            <PublishDescription maxWidth="240px" tooltipText={`Deployment Name: ${publishDescription}`} forceTooltip data-testid="notification-publish-description">
              {publishDescription}
            </PublishDescription>
          </Stack>
        }
        <StatusContainer>
          <StatusBadge status={statusStyle} data-testid="notification-status-badge">
            <Typography variant="tooltip">
              {STATUS_DISPLAY_TEXT[status]}
            </Typography>
          </StatusBadge>
          <SmallText sx={{ mr: "auto" }} data-testid="notification-step-text">
            {stepText}
          </SmallText>
          {!isExpanded && <SmallText data-testid="notification-relative-time">
            {formatRelativeTime(createdAt)}
          </SmallText>}
        </StatusContainer>
      </ContentContainer>
    </NotificationContainer>
  );
};

export default NotificationItem;
